<menu-header></menu-header>
<nav id="nav" role="navigation">

	<a tabindex="0" class="wt-auto-dashboard"
		[ngClass]="{ active: '/app' == menuService.pathActive || '' == menuService.pathActive }"
		routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="menuService.nav('/app')"
		(keypress)="menuService.nav('/app')">
		<img alt="Dashboard" class="icon" src="/assets/img/icons/dashboard@2x.png" style="height: 20px" />
		<span translate>menu.dashboard</span>
	</a>

	<ng-container *accessControl="'moodcheck'">
		<a tabindex="0" class="wt-auto-moodcheck-show" [ngClass]="{ disabled: menuService.locked }"
			(click)="menuService.nav('/app/mood-check')" (keypress)="menuService.nav('/app/mood-check')">
			<img alt="Moodcheck" class="icon" src="/assets/img/icons/moodcheck@2x.png" style="height: 19px" />
			<span translate>menu.moodcheck</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'favorites'">
		<a tabindex="0"
			[ngClass]="{ active: '/app/favourites' == menuService.pathActive}"
			[ngClass]="{ disabled: menuService.locked }" (click)="menuService.nav('/app/favourites')"
			(keypress)="menuService.nav('/app/favourites')">
			<img alt="Favourites" class="icon" src="/assets/img/icons/icon_sidebar_fav.svg" style="height: 19px" />
			<span translate>Favourites</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'courses'">
		<a tabindex="0" class="wt-auto-courses-show"
			[ngClass]="{ active: ('/app/series' == menuService.pathActive || menuService.pathActive.search('courses-listing') !== -1), disabled:  menuService.locked }"
			routerLinkActive="active" (click)="menuService.nav('/app/series')"
			(keypress)="menuService.nav('/app/series')">
			<img alt="Courses" class="icon" src="/assets/img/icons/practice@2x.png" style="height: 20px" />
			<span translate>menu.courses</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'community'">
		<a *ngIf="enableTogetherAll" tabindex="0" class="wt-auto-courses-show"
			[ngClass]="{ active: '/app/community' == menuService.pathActive, disabled: menuService.locked }"
			routerLinkActive="active" (click)="menuService.nav('/app/community')"
			(keypress)="menuService.nav('/app/community')">
			<img alt="Courses" class="icon" src="/assets/img/icons/community.svg" style="height: 20px" />
			<span translate>menu.community</span>
		</a>
	</ng-container>
	<!--
	<a
		tabindex="0"
		[ngClass]="{ active: '/app/dated-event-listing' == menuService.pathActive, disabled: menuService.locked }"
		routerLinkActive="active"
		*ngIf="menuService.practiceShow"
		(click)="menuService.nav('/app/dated-event-listing')"
		(keypress)="menuService.nav('/app/dated-event-listing')"
		[ngClass]="{ disabled: menuService.locked }"
	>
		<img
			alt="Dated Events"
			class="icon"
			src="/assets/img/icons/calendar@2x.png"
			style="height: 20px"
		/>
		<span translate>menu.datedEvents</span>
	</a>


	<ng-container *accessControl="'podcasts'">
		<a *accessControl="'podcasts'" tabindex="0"
			[ngClass]="{ active: '/app/podcasts' == menuService.pathActive,  disabled: menuService.locked }"
			routerLinkActive="active" (click)="menuService.nav('/app/podcasts')"
			(keypress)="menuService.nav('/app/podcasts')">
			<img alt="Courses" class="icon" src="/assets/img/icons/podcast-mic@2x.png" style="height: 20px" />
			<span translate>menu.podcasts</span>
		</a>
	</ng-container>
	-->


	<ng-container *accessControl="'wellnessDomains'">
		<a *ngIf="menuService.enableCoreContributors" tabindex="0" [ngClass]="{
			active: '/app/corecontributors' == menuService.pathActive,
			disabled: menuService.locked
		}" routerLinkActive="active" (click)="menuService.nav('/app/corecontributors')"
			(keypress)="menuService.nav('/app/corecontributors')" [ngClass]="{ disabled: menuService.locked }">
			<img alt="Domains" class="icon" src="/assets/img/icons/resources@2x.png" style="height: 20px" />
			<span translate>menu.wellnessDomains</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'practice'">
		<a tabindex="0" class="wt-auto-practice-show"
			[ngClass]="{ active: '/app/practice' == menuService.pathActive, disabled: menuService.locked }"
			routerLinkActive="active" (click)="menuService.nav('/app/practice')"
			(keypress)="menuService.nav('/app/practice')" [ngClass]="{ disabled: menuService.locked }">
			<img alt="Tools" class="icon" src="/assets/img/icons/theory@2x.png" style="height: 20px" />
			<span translate>menu.tools</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'calendar'">
		<a tabindex="0" class="wt-auto-calendar-show"
			[ngClass]="{ active: '/app/calendar' == menuService.pathActive, disabled: menuService.locked }"
			routerLinkActive="active" (click)="menuService.nav('/app/calendar')"
			(keypress)="menuService.nav('/app/calendar')">
			<img alt="Calendar" class="icon" src="/assets/img/icons/calendar@2x.png" style="height: 20px" />
			<span translate>menu.calendar</span>
			<div class="notifications" *ngIf="menuService.user.eventCount > 0">
				{{ menuService.user.eventCount }}
			</div>
		</a>
	</ng-container>
	<!--
		Change this to include logic to detect if more than one assessment is enabled. 
		 In which case,  general assessment page is required
	<ng-container *accessControl="'assessment'">
		<a tabindex="0" class="wt-auto-assessments-show" [ngClass]="{
				active: '/app/assessments' == menuService.pathActive,
				disabled: menuService.locked
			}" routerLinkActive="active" *ngIf="menuService.defaultAssessment === 'resilience'"
			(click)="menuService.nav('/app/assessments')" (keypress)="menuService.nav('/app/assessments')">
			<img alt="Assessment" class="icon" src="./assets/img/icons/assessment_icon@2x.png" style="height: 20px" />
			<span translate>menu.assessments</span>
		</a>
	</ng-container>
	-->
	<ng-container *accessControl="'assessment'">
		<a tabindex="0" class="wt-auto-das-show" [ngClass]="{
			active: '/app/assessment' == menuService.pathActive,
			disabled: menuService.locked
		}" routerLinkActive="active" *ngIf="menuService.assessmentShow && menuService.defaultAssessment === 'das'"
			(click)="menuService.nav('/app/assessments/listing')"
			(keypress)="menuService.nav('/app/assessments/listing')">
			<img alt="Assessment" class="icon" src="./assets/img/icons/assessment_icon@2x.png" style="height: 20px" />
			<span translate>menu.assessment</span>
		</a>
	</ng-container>
	<!-- <a
		tabindex="0"
		class="wt-auto-das-show"
		[ngClass]="{ active: '/app/nps-survey' == menuService.pathActive, disabled: menuService.locked }"
		routerLinkActive="active"
		(click)="menuService.nav('/app/nps-survey')"
		(keypress)="menuService.nav('/app/nps-survey')"
	>
		<img
		alt="Assessment"
		class="icon"
		src="./assets/img/icons/survey.svg"
		style="height: 20px"
/>
		<span translate>menu.npsSurvey</span>
	</a> -->

	<ng-container *accessControl="'challenges'">
		<a tabindex="0" class="wt-auto-challenges-show" [ngClass]="{
				active: '/app/challenges' == menuService.pathActive,
				disabled: menuService.locked
			}" routerLinkActive="active" *ngIf="menuService.user.totalChallengesCount > 0"
			(click)="menuService.nav('/app/challenges')" (keypress)="menuService.nav('/app/challenges')"
			[ngClass]="{ disabled:  menuService.locked }">
			<i aria-hidden="true" class="fa fa-flag" aria-hidden="true"></i>
			<span translate>menu.challenges</span>
			<div class="notifications" *ngIf="menuService.user.activeChallengesCount > 0">
				{{ menuService.user.activeChallengesCount }}
			</div>
		</a>
	</ng-container>

	<ng-container *accessControl="'emergencyContact'">
		<a tabindex="0" class="wt-auto-emergency-contact-show secondary" [ngClass]="{
			active: '/app/emergency-contact' == menuService.pathActive,
			disabled: menuService.locked
		}" routerLinkActive="active" (click)="menuService.nav('/app/emergency-contact')"
			(keypress)="menuService.nav('/app/emergency-contact')" *ngIf="menuService.user.primaryOrganization">
			<img alt="Emergency contact" class="icon" src="/assets/img/icons/hand@2x.png" style="height: 22px" />
			<span translate *ngIf="resilienceEnable">menu.emergencyResilience</span>
			<span translate *ngIf="!resilienceEnable">menu.emergency</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'resources'">
		<a tabindex="0" class="wt-auto-resources-show secondary"
			[ngClass]="{ active: '/app/resources' == menuService.pathActive, disabled: menuService.locked }"
			routerLinkActive="active" *ngIf="menuService.enableResources" (click)="menuService.nav('/app/resources')"
			(keypress)="menuService.nav('/app/resources')">
			<img alt="Resources" class="icon" src="/assets/img/icons/resources@2x.png" style="height: 22px" />
			<span translate>menu.resources</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'syncWithCounselor'">
		<a tabindex="0" class="wt-auto-counselors-show secondary" [ngClass]="{
				active: '/app/counselor-sync' == menuService.pathActive,
				disabled: menuService.locked
			}" routerLinkActive="active" *ngIf="menuService.user.primaryOrganization &&
			menuService.user.primaryOrganization.settings &&
			menuService.user.primaryOrganization.settings.hasCounselors
			" (click)="menuService.nav('/app/counselor-sync')" (keypress)="menuService.nav('/app/counselor-sync')">
			<img alt="Sync with counselor" class="icon" src="./assets/img/icons/cloud@2x.png" style="height: 18px" />
			<span translate>menu.sync</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'settings'">
		<a tabindex="0" class="wt-auto-settings-show secondary"
			[ngClass]="{ active: '/app/settings' == menuService.pathActive, disabled: menuService.locked }"
			routerLinkActive="active" (click)="menuService.nav('/app/settings')"
			(keypress)="menuService.nav('/app/settings')">
			<img alt="Settings" class="icon" src="./assets/img/icons/settings@2x.png" style="height: 15px" />
			<span translate>menu.setting</span>
		</a>
	</ng-container>

	<ng-container *accessControl="'support'">
		<a tabindex="0" class="wt-auto-support-show secondary"
			[ngClass]="{ active: '/app/support' == menuService.pathActive, disabled: menuService.locked }"
			routerLinkActive="active" (click)="menuService.onSupportClick()" (keypress)="menuService.onSupportClick()">
			<i class="fa fa-envelope" aria-hidden="true"></i>
			<span translate>menu.support</span>
		</a>
	</ng-container>

</nav>
<menu-footer></menu-footer>